/* Helpers shared across the mock-adapter domain files. */

import * as store from "@/data/mocks/storage";

export const MOCK_LATENCY_MS = [120, 400];

/** Append an entry to the audit log (capped to the last 100 events). */
export function pushAudit(entry) {
  if (typeof window === "undefined") return;
  const log = store.get("audit_log", []) || [];
  const next = [{ ts: new Date().toISOString(), ...entry }, ...log].slice(0, 100);
  store.set("audit_log", next);
}

/** Read the current session — convenience used by every mutator. */
export function getSession() {
  return store.get("session", null);
}

/** Wrap a value in a Promise that resolves after a random delay. */
export function withLatency(value, range = MOCK_LATENCY_MS) {
  const [min, max] = range;
  const delay = min + Math.random() * (max - min);
  return new Promise((resolve) => setTimeout(() => resolve(value), delay));
}

/** Reject with a Response-like error after a short delay. */
export function withError(message, status = 400) {
  return new Promise((_, reject) =>
    setTimeout(() => {
      const err = new Error(message);
      err.status = status;
      err.data = { detail: message };
      reject(err);
    }, 80)
  );
}

/** Paginate an array using { limit, offset }. */
export function paginate(items, { limit = 24, offset = 0 } = {}) {
  return {
    total: items.length,
    limit,
    offset,
    items: items.slice(offset, offset + limit),
  };
}

/** Generate a tiny random token. Sufficient for mock auth. */
export function makeToken(prefix = "mock") {
  return `${prefix}_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}
